import { render, staticRenderFns } from "./PagesBar.vue?vue&type=template&id=3af03e01&scoped=true&"
import script from "./PagesBar.vue?vue&type=script&lang=js&"
export * from "./PagesBar.vue?vue&type=script&lang=js&"
import style0 from "./PagesBar.vue?vue&type=style&index=0&id=3af03e01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af03e01",
  null
  
)

export default component.exports